import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAuthHeader } from 'react-auth-kit';
import { config } from 'variables/config';

const BASE = `${config.app.api_url}/schedulers`;

function authHeaders(authHeader) {
  return { headers: { Authorization: authHeader() } };
}

export function useNotificationCycles() {
  const authHeader = useAuthHeader();
  return useQuery({
    queryKey: ['notification-cycles'],
    queryFn: async () => {
      const { data } = await axios.get(`${BASE}/notification-cycles`, authHeaders(authHeader));
      return data;
    },
    staleTime: 60 * 1000,
  });
}

export function useNotificationAttempts(enterpriseId) {
  const authHeader = useAuthHeader();
  return useQuery({
    queryKey: ['notification-attempts', enterpriseId],
    queryFn: async () => {
      const { data } = await axios.get(
        `${BASE}/enterprises/${enterpriseId}/notification-attempts`,
        authHeaders(authHeader)
      );
      return data;
    },
    enabled: !!enterpriseId,
    staleTime: 30 * 1000,
  });
}

export function useSchedulerConfig() {
  const authHeader = useAuthHeader();
  return useQuery({
    queryKey: ['scheduler-config'],
    queryFn: async () => {
      const { data } = await axios.get(`${BASE}/config`, authHeaders(authHeader));
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useNotificationAttemptsSummary(enterpriseId) {
  const authHeader = useAuthHeader();
  return useQuery({
    queryKey: ['notification-attempts-summary', enterpriseId],
    queryFn: async () => {
      const { data } = await axios.get(
        `${BASE}/enterprises/${enterpriseId}/notification-attempts/summary`,
        authHeaders(authHeader)
      );
      return data;
    },
    enabled: !!enterpriseId,
    staleTime: 30 * 1000,
  });
}
